import { createSlice } from '@reduxjs/toolkit';
import { getAddressListThunk, getUserDetailsThunk } from '../thunks/userThunk';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userDetails: "",
    addressList: ''
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserDetailsThunk.fulfilled, (state, action) => {
        state.userDetails = action.payload?.data;
      })
      .addCase(getAddressListThunk.fulfilled, (state, action) => {
        state.addressList = action.payload?.data;
      })
  },
});

// export const { logout } = userSlice.actions;

export default userSlice.reducer;
